import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator, MatSort } from '@angular/material';
import {MatDialog, MatDialogConfig} from "@angular/material";
import {SelectionModel} from '@angular/cdk/collections';
import {FormControl} from '@angular/forms';

import { SalesTableDataSource } from './sales-table-datasource';
import { SalesLeadsService } from '../services/sales-leads.service';
import { SalesTableItem } from './sales-table-datasource';
import { GenericDialogComponent } from '../generic-dialog/generic-dialog.component';
import { SelectAgentDialogComponent } from '../select-agent-dialog/select-agent-dialog.component';
import { Timestamp } from '@firebase/firestore';
@Component({
  selector: 'app-sales-table',
  templateUrl: './sales-table.component.html',
  styleUrls: ['./sales-table.component.css'],
  providers: []
})
export class SalesTableComponent implements OnInit {
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  dataSource: SalesTableDataSource;
  filterValue: string;
  agentModel;

  /** Columns displayed in the table. Columns IDs can be added, removed, or reordered. */
  displayedColumns = ['name', 'phone', 'location', 'status', 'comments','agent', 'updatedAt', 'actions' ];
  selection = new SelectionModel<SalesTableItem>(true, []);

  agentList = [{name : "Aswathi R", email: "aswathir@homigo.in"},{name : "Palak", email: "palak@homigo.in"},{name: "Praveen", email: "praveen@homigo.in"},{name:"Hadly", email: "hadlygonsalves@homigo.in"},{name:"Nikhil D Cruz", email: "nikhildecruz@homigo.in"}, {name:"Faizan", email: "faizanahmed@homigo.in"}];
  statusList = ['Assigned', 'Visit Scheduled','In loop','converted','dead'];
  constructor(private sls: SalesLeadsService, private dialog: MatDialog){
    this.filterValue = '';
  }


  ngOnInit() {
    this.dataSource = new SalesTableDataSource(this.sls, this.paginator, this.sort);
  }
  applyFilter(filterValue: string) {
    console.log("Filter value is "+ filterValue);
    this.dataSource.filterFunc(filterValue.trim().toLowerCase());
  }

  noteUpdate( temp, event){
    console.log("Notes updated ",temp);
    this.sls.noteUpdate(temp);
  }

  agentUpdate(temp){
    console.log("Selection change ",temp);
    this.dataSource.agentSelection(temp.value);
  }

  openDialog(ques: string, reasonArray, statusType) {

        const dialogConfig = new MatDialogConfig();

        dialogConfig.disableClose = false;
        dialogConfig.autoFocus = true;
        dialogConfig.data = {
          question: ques,
          reasons: reasonArray,
          type: statusType
        };

        console.log("Opening dialog");
        const dialogRef = this.dialog.open(GenericDialogComponent, dialogConfig);
        return dialogRef;
        // dialogRef.afterClosed().subscribe((sel)=> {
        //   console.log("Selection is ", sel);
        //   return sel;
        // });
      //  dialogRef.on
      }

  reassign(row){
    const dialogConfig = new MatDialogConfig();

    dialogConfig.disableClose = false;
    dialogConfig.autoFocus = true;
    dialogConfig.data = {
      list: this.agentList,
      agent: row.agent,
    };

    const dialogRef = this.dialog.open(SelectAgentDialogComponent, dialogConfig);
    dialogRef.afterClosed().subscribe((sel) => {
      if(sel === undefined){
        console.log("No agent selection revieved.");
        return;
      }
      console.log("Selected agent recieved ", sel.name);
      //Call sls service to update agent
      this.sls.reassignAgent(row, sel);
    });
  }

  statusUpdate(val, row){
    console.log("Status Updated ", val);
    console.log("Status Updated ", row);


    if(val.value == 'In loop'){
      this.sls.statusUpdate(row);
    }
    else if(val.value == 'Visit Scheduled'){
      this.sls.statusUpdate(row);
    }

    else if(val.value == 'converted'){
      //open modal
      console.log("Opening modal in converted");
      const convertReasons = ['Visit was great','3 Month Security Deposit', 'Community','other'];
      this.openDialog('What made it work?', convertReasons ,'converted').afterClosed().subscribe((sel)=> {
        console.log('selected conversion reason is ', sel);
        if(sel == ''){
          console.log("no selection");
          return;
        }
        this.sls.markConverted(row, sel);
      });
            //update using sls service
    }

    else if(val.value == 'dead'){
      //open modal
      console.log("Opening modal in dead");
      console.log("Status Updated ", val);
      const deadReasons: string[] = [ 'Out of Budget','Unfavourable location','Poor Visit UX','Property Not Available','Does not want unfurnished', 'Discontent with Pricing Policy','Found another place'];
      this.openDialog("What went wrong", deadReasons ,'dead').afterClosed().subscribe((sel)=>{
        console.log("Selected reason is ", sel);
        if(sel == ''){
          console.log("no selection");
          return;
        }
        //update using sls service
        this.sls.markDead(row, sel);

    });;

    }


    else{
      this.sls.statusUpdate(row);
    }

  }


  /*
  */
  leadCalled(row: SalesTableItem){
    //const tStamp = Timestamp
    console.log("Phone call was placed to ", row);
  }
  /*
  */
  markGroupDead(){
    console.log("Mark dead clicked");
  }
  /** Whether the number of selected elements matches the total number of rows. */
  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;
    return numSelected === numRows;
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle() {
    this.isAllSelected() ?
        this.selection.clear() :
        this.dataSource.data.forEach(row => this.selection.select(row));
  }
}
